import React from "react";
import "../styles/ArancelesEco.css";

const ArancelesEco = () => {
  return (
    <div className="container my-5">
      <h1 className="text-center mb-4">Aranceles de Ecografías y Cardiología</h1>
      <div className="table-responsive">
        <table className="tableizer-table">
          <thead>
            <tr className="tableizer-firstrow">
              <th>Especialidad</th>
              <th>Tratamiento</th>
              <th>Código</th>
              <th>Precio FONASA</th>
              <th>Precio Particular / ISAPRE</th>
              <th>Tiempo</th>
              <th>Indicaciones</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Ecografías</td>
              <td>0404003 ECOGRAFÍA ABDOMINAL</td>
              <td>0404003</td>
              <td>$29.790</td>
              <td>$40.000</td>
              <td>00:15:00</td>
              <td>Se requiere acudir con ayuno mínimo de 6 horas, pacientes desde los 4 años hacia arriba, 4 horas para 4 años, y sin preparación en el caso de recién nacidos hasta los 2 años.</td>
            </tr>
            <tr>
              <td>Ecografías</td>
              <td>0404009 ECOGRAFÍA PELVIANA MASCULINA</td>
              <td>0404009</td>
              <td>$16.570</td>
              <td>$25.000</td>
              <td>00:15:00</td>
              <td>Acudir con vejiga llena (beber abundante líquido, sin orinar antes del examen).</td>
            </tr>
            <tr>
              <td>Ecografías</td>
              <td>0404010 ECOGRAFÍA RENAL</td>
              <td>0404010</td>
              <td>$20.660</td>
              <td>$25.000</td>
              <td>00:15:00</td>
              <td>Se recomienda acudir en ayuno de 6 horas.</td>
            </tr>
            <tr>
              <td>Ecografías</td>
              <td>0404012 ECOGRAFÍA MAMARIA femenina o masculina</td>
              <td>0404012</td>
              <td>$20.770</td>
              <td>$40.000</td>
              <td>00:15:00</td>
              <td>Sin preparación. Si la paciente es mayor de 40 años, es obligatorio acudir con la última mamografía realizada (no mayor a 1 año), además de acudir con ecografías previas si las tuviera. Menores de 40 años, acudir con ecografías previas si las tuviera.</td>
            </tr>
            <tr>
              <td>Ecografías</td>
              <td>0404014 ECOGRAFÍA TESTICULAR</td>
              <td>0404014</td>
              <td>$20.490</td>
              <td>$35.000</td>
              <td>00:15:00</td>
              <td>Sin preparación.</td>
            </tr>
            <tr>
              <td>Ecografías</td>
              <td>0404015 ECOGRAFÍA DE TIROIDES</td>
              <td>0404015</td>
              <td>$20.770</td>
              <td>$35.000</td>
              <td>00:15:00</td>
              <td>Sin preparación, acudir con ecografías previas si las tuviera.</td>
            </tr>
            <tr>
              <td>Cardiología</td>
              <td>Ecocardiograma 17 01 045 FONASA</td>
              <td>1701045</td>
              <td>$82.180</td>
              <td>$120.000</td>
              <td>00:20:00</td>
              <td>Sin preparación.</td>
            </tr>
            <tr>
              <td>Cardiología</td>
              <td>Electrocardiograma 17 01 001 FONASA</td>
              <td>1701001</td>
              <td>$8.230</td>
              <td>$11.500</td>
              <td>00:20:00</td>
              <td>Sin preparación.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ArancelesEco;